import { render, staticRenderFns } from "./LgFinderPageItemBemPermanente.vue?vue&type=template&id=ad19e786"
import script from "./LgFinderPageItemBemPermanente.vue?vue&type=script&lang=js"
export * from "./LgFinderPageItemBemPermanente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports